export interface PackageDimensionLine {
  product_id: string
  quantity: number
}

export interface PackageDimensions {
  largo: number
  ancho: number
  altura: number
  peso: number
  usarPaqueteTerrestre: boolean
}

interface DimensionState {
  maxLargo: number
  maxAncho: number
  totalPeso: number
  totalAlto: number
  todosTienenLargo: boolean
  todosTienenAncho: boolean
  todosTienenPeso: boolean
  todosTienenAlto: boolean
  usarPaqueteTerrestre: boolean
}

function consumeProduct(detail: any, units: number, state: DimensionState) {
  if (!detail.longitud || detail.longitud <= 0) {
    state.todosTienenLargo = false
  } else if (detail.longitud > state.maxLargo) {
    state.maxLargo = detail.longitud
  }

  if (!detail.ancho || detail.ancho <= 0) {
    state.todosTienenAncho = false
  } else if (detail.ancho > state.maxAncho) {
    state.maxAncho = detail.ancho
  }

  if (!detail.peso || detail.peso <= 0) {
    state.todosTienenPeso = false
    if (detail.peso >= 0 && detail.peso <= 8) {
      state.usarPaqueteTerrestre = true
    }
  } else {
    state.totalPeso += detail.peso * units
    if (detail.peso >= 0 && detail.peso <= 8) {
      state.usarPaqueteTerrestre = true
    }
  }

  if (!detail.alto || detail.alto <= 0) {
    state.todosTienenAlto = false
  } else {
    state.totalAlto += detail.alto * units
  }
}

/**
 * Misma regla que Crear Envío:
 * largo y ancho son el máximo; alto y peso se suman por cantidad.
 * Si falta una medida, esa dimensión queda en 0.
 * Los combos también suman sus componentes.
 */
export function calculatePackageDimensions(
  lineItems: PackageDimensionLine[],
  productDetails: Record<string, any>
): PackageDimensions {
  const state: DimensionState = {
    maxLargo: 0,
    maxAncho: 0,
    totalPeso: 0,
    totalAlto: 0,
    todosTienenLargo: true,
    todosTienenAncho: true,
    todosTienenPeso: true,
    todosTienenAlto: true,
    usarPaqueteTerrestre: false
  }

  lineItems.forEach(item => {
    const productDetail = productDetails[item.product_id]
    if (!productDetail) return

    consumeProduct(productDetail, item.quantity, state)

    if (productDetail.is_combo === 1 && productDetail.components) {
      productDetail.components.forEach((component: any) => {
        const componentDetails = productDetails[component.sku]
        if (!componentDetails) return
        const cantidadComponente = component.quantity * item.quantity
        consumeProduct(componentDetails, cantidadComponente, state)
      })
    }
  })

  return {
    largo: state.todosTienenLargo ? state.maxLargo : 0,
    ancho: state.todosTienenAncho ? state.maxAncho : 0,
    altura: state.todosTienenAlto ? state.totalAlto : 0,
    peso: state.todosTienenPeso ? state.totalPeso : 0,
    usarPaqueteTerrestre: state.usarPaqueteTerrestre
  }
}

export function tipoServicioFromPeso(peso: number): '12' | '3' {
  return peso <= 8 ? '12' : '3'
}
